import Revelar from './Revelar';
import styles from './LandingBase.module.css';

type Props = {
  onClick?: () => void;
};

const selos = ['Sem planilha', 'Projeção do mês', 'Metas por categoria', 'Lançamento em segundos', 'Tudo num lugar', 'Em português'];

type TomStat = 'entrada' | 'saida' | 'saldo';

const estatisticas: { rotulo: string; valor: string; tom: TomStat }[] = [
  { rotulo: 'Entradas', valor: '+R$ 5.240', tom: 'entrada' },
  { rotulo: 'Saídas', valor: 'R$ 3.180', tom: 'saida' },
  { rotulo: 'Saldo', valor: 'R$ 2.060', tom: 'saldo' }
];

// Cores de categoria são "dado" (como no produto real, cada categoria tem sua cor).
const categorias = [
  { icone: 'home', nome: 'Moradia', valor: 'R$ 1.400', largura: '100%', cor: '#0ea5e9', estouro: '' },
  { icone: 'restaurant', nome: 'Alimentação', valor: 'R$ 980', largura: '70%', cor: '#f59e0b', estouro: '' },
  { icone: 'directions_car', nome: 'Transporte', valor: 'R$ 380', largura: '27%', cor: '#10b981', estouro: '' },
  { icone: 'sports_esports', nome: 'Lazer', valor: 'R$ 210', largura: '100%', cor: '#ec4899', estouro: '105% da meta, R$ 10 acima' }
];

const Main = ({ onClick = () => {} }: Props) => {
  const verComo = () => document.getElementById('como')?.scrollIntoView({ behavior: 'smooth' });

  const classesTomStat: { [tom in TomStat]: string } = {
    entrada: styles.mockStatIn,
    saida: styles.mockStatOut,
    saldo: styles.mockStatBal
  };

  return (
    <>
      <section className={styles.hero}>
        <div className={styles.heroInner}>
          <Revelar>
            <span className={styles.badge}>
              <span className={styles.pip} />
              Suas finanças, sem planilha
            </span>
          </Revelar>

          <Revelar atraso={80}>
            <h1 className={styles.h1}>
              Saiba pra onde vai cada real, <span className={styles.gradText}>sem planilha</span>
            </h1>
          </Revelar>

          <Revelar atraso={160}>
            <p className={styles.subhead}>
              Contas, cartões e gastos <strong>num só lugar</strong>, <strong>projeção de como o mês vai fechar</strong> e metas que
              avisam antes de estourar. Finanças organizadas, sem planilha pra manter.
            </p>
          </Revelar>

          <Revelar atraso={240} className={styles.ctaWrap}>
            <div className={styles.ctaRow}>
              <button className={styles.btnPrimaryLg} onClick={onClick}>
                Começar grátis
              </button>
              <button className={styles.btnSecondaryLg} onClick={verComo}>
                Ver como funciona
              </button>
            </div>
            <span className={styles.trust}>Lançamento em segundos · Tudo num lugar · Comece em 2 minutos</span>
          </Revelar>

          {/* Mock do produto (HTML/CSS, não é imagem): miniatura fiel do dashboard real */}
          <Revelar atraso={320} className={styles.mockWrap}>
            <div className={styles.mock}>
              <div className={styles.mockHeader}>
                <span className={styles.mockTitle}>Seu mês num relance</span>
                <span className={styles.mockMonth}>Julho</span>
              </div>

              <div className={styles.mockStats}>
                {estatisticas.map((estatistica) => (
                  <div key={estatistica.rotulo} className={styles.mockStat}>
                    <span className={styles.mockStatLabel}>{estatistica.rotulo}</span>
                    <span className={`${styles.mockStatValue} ${classesTomStat[estatistica.tom]}`}>{estatistica.valor}</span>
                  </div>
                ))}
              </div>

              <div className={styles.mockInsight}>
                <span className={`${styles.mockInsightIcon} material-symbols-rounded`}>bolt</span>
                <span className={styles.mockInsightText}>
                  No ritmo atual, seu mês fecha com <strong>R$ 780 de folga</strong>
                </span>
              </div>

              <div className={styles.mockPanel}>
                <span className={styles.mockSectionTitle}>Pra onde foi seu dinheiro</span>
                <div className={styles.mockCats}>
                  {categorias.map((categoria) => (
                    <div key={categoria.nome} className={styles.mockCat}>
                      <span
                        className={`${styles.mockCatIcon} material-symbols-rounded`}
                        style={{ color: categoria.cor, background: `${categoria.cor}1f` }}
                      >
                        {categoria.icone}
                      </span>
                      <div className={styles.mockCatBody}>
                        <div className={styles.mockCatTop}>
                          <span className={styles.mockCatName}>{categoria.nome}</span>
                          <span className={`${styles.mockCatValue} ${categoria.estouro ? styles.mockCatValueOver : ''}`}>
                            {categoria.valor}
                          </span>
                        </div>
                        <div className={styles.mockBar}>
                          <div
                            className={styles.mockBarFill}
                            style={{ width: categoria.largura, background: categoria.estouro ? 'var(--error)' : categoria.cor }}
                          />
                        </div>
                        {categoria.estouro && <span className={styles.mockCatMeta}>{categoria.estouro}</span>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <span className={styles.mockCaption}>Assim é o seu dashboard: projeção, metas e clareza num relance.</span>
          </Revelar>
        </div>
      </section>

      <div className={styles.marquee}>
        <div className={styles.marqueeTrack}>
          {[...selos, ...selos].map((selo, i) => (
            <span key={i} className={styles.marqueeItem}>
              {selo}
            </span>
          ))}
        </div>
      </div>
    </>
  );
};

export default Main;
